import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55ce2f90"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "tw-flex tw-w-full tw-min-h-[50px] tw-items-center tw-justify-between" }
const _hoisted_3 = { class: "tw-flex tw-w-full tw-gap-[15px] tw-items-center" }
const _hoisted_4 = { class: "tw-truncate org-topic-title" }
const _hoisted_5 = { class: "tw-truncate org-topic-title !tw-text-[11px]" }

import { computed } from "vue";
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

/** components */
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'orgTopic',
  props: {
    data: {}
  },
  emits: ["close-menu"],
  setup(__props: any, { emit }) {

const props = __props;





const currentOrg = computed<Record<string, any>>(
  () => store.state.Org.currentOrg,
);

const onSwitchOrg = async () => {
  await store.dispatch("Org/switchOrg", { orgId: props.data.id });
  emit("close-menu");
};

const onSelectOrg = () => {
  emit("close-menu");
  EventEmitter.emit(
    EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
    props.data.name,
  );
};

return (_ctx: any,_cache: any) => {
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer",
    onClick: _withModifiers(onSelectOrg, ["stop"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(GlobalAvatar, {
          name: _ctx.data.name,
          "class-name": "!tw-w-[30px] !tw-h-[30px]"
        }, null, 8, ["name"]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data.name), 1)
      ]),
      (currentOrg.value.id !== _ctx.data.id)
        ? (_openBlock(), _createBlock(_component_BButton, {
            key: 0,
            variant: "",
            class: "tw-flex tw-items-center tw-w-[121px] tw-max-w-[121px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-px-[13px] tw-py-[10px] tw-rounded-[100px] tw-h-[34px] tw-mr-[50px] hover:tw-bg-[#eff0f1]",
            onClick: _withModifiers(onSwitchOrg, ["stop"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-header-menu-search-text-switch-org-1")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(IconRight)
  ], 8, _hoisted_1))
}
}

})